module.exports = __webpack_public_path__ + "static/img/kt.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/kt.jpg
// module id = 8zcr
// module chunks = 0